import styled from 'styled-components';

export const Container = styled.div<{ last: boolean }>`
  border-bottom: ${({ last }) => (last ? '' : '1px solid var(--color-dd-border__primary)')};
  height: 56px;
  display: flex;
  align-items: center;
  label {
    display: flex;
    align-items: flex-start;
    min-height: 2.5rem;
    width: 100%;

    .ant-radio {
      top: 0.625rem;
      .ant-radio-inner {
        border-color: var(--bose-item__modifier-button-outline);
        background-color: var(--bose-item__modifier-button-background);
      }
    }

    .ant-radio-checked .ant-radio-inner:after {
      background-color: var(--bose-item__modifier-button-selected);
    }

    .ant-checkbox {
      top: 0.625rem;

      > .ant-checkbox-input,
      > .ant-checkbox-inner {
        min-height: 1.25rem;
        min-width: 1.25rem;
      }

      .ant-checkbox-inner {
        border-color: var(--bose-item__modifier-button-outline);
        background-color: var(--bose-item__modifier-button-background);
      }
    }

    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: var(--bose-item__modifier-button-selected);
    }

    span.ant-checkbox + *,
    span.ant-radio + * {
      width: 100%;
    }

    // These styles are used to account for the addition of qty buttons for checkboxes which requires all
    // radios/checkboxes to be shifted right so they are all left aligned
    &.ant-radio-wrapper {
      > span:first-child {
        margin-left: 0.625rem; // Needed so that it can be left aligned with the checkboxes
      }
    }

    &.ant-checkbox-wrapper {
      > span:first-child {
        margin-left: 0.625rem; // Needed so that if there is a quantity then it will be at same position as decrement button
      }

      > span:nth-of-type(2) {
        display: flex;
        flex-direction: row;
      }

      &.ant-checkbox-wrapper-checked.modifier-allow-quantities {
        .ant-checkbox {
          &.ant-checkbox-checked {
            display: none;
            top: auto;

            & + span {
              padding-left: 0;
            }
          }
        }
      }
    }
  }

  &:last-child > label {
    margin-bottom: 0;
  }
`;
export const Content = styled.div`
  padding-top: 0.75rem;
  flex-grow: 1;
`;
export const EditQuantity = styled.div`
  align-items: center;
  display: flex;
  padding-right: 0.125rem;
`;
export const Row = styled.div`
  display: flex;
  font-weight: 500;
  font-size: 0.875rem;
  flex-direction: row;
  justify-content: space-between;
  line-height: 1;

  span {
    display: flex;
  }
`;
export const RowLeft = styled.span`
  display: flex;
  margin-right: 1rem;
  color: var(--bose-item__modifier-option-text);
`;
export const RowRight = styled.span`
  color: var(--bose-item__modifier-option-price-text);
`;
export const Qty = styled.div`
  color: var(--color-neutral__title-active);
  font-size: 0.875rem;
  font-weight: bold;
  min-width: 1rem;
  padding: 0;
  text-align: center;
`;
export const UpdateButton = styled.button`
  align-items: center;
  background-color: var(--color-neutral__modal-background);
  border: none;
  display: flex;
  justify-content: center;
  min-height: 2.5rem; // Make the button large so it's more clickable
  min-width: 2.5rem; // Make the button large so it's more clickable
  padding: 0;
  position: relative;

  // Animate the shadow on hover
  &:after {
    background: var(--color-neutral__line);
    border-radius: 50%;
    bottom: auto;
    content: '';
    height: 1.25rem;
    left: 10px;
    position: absolute;
    top: 10px;
    transform: scale(1);
    transition: transform 0.08s ease-in;
    width: 1.25rem;
  }

  // The first nested div marks the visible button
  > div {
    align-items: center;
    display: flex;
    justify-content: center;
    position: relative;
    width: 100%;

    > span {
      align-items: center;
      background-color: var(--color-neutral__modal-background);
      border: 1px solid var(--color-neutral__line);
      border-radius: 50%;
      color: var(--color-neutral__title-active);
      display: flex;
      height: 1.25rem;
      justify-content: center;
      min-height: 1.25rem;
      min-width: 1.25rem;
      padding-right: 0;
      position: relative;
      width: 1.25rem;
      z-index: 1;
    }
  }

  &:disabled {
    cursor: not-allowed;

    > div > span {
      background-color: #f5f5f5;
      border-color: #d9d9d9;
      color: rgba(0, 0, 0, 0.25);
    }
  }

  &:focus:not(:disabled),
  &:hover:not(:disabled) {
    > div > span {
      border-color: var(--color-neutral__title-active);
      color: var(--color-neutral__title-active);
    }
  }

  &:hover:not(:disabled) {
    &:after {
      transform: scale(1.5);
    }
  }
`;
